import { defineStore } from 'pinia'

interface Page {
  type: 'content' | 'category' | null
}

export const usePageStore = defineStore('page', {
  state: () => ({
    page: {
      type: null,
    } as Page,
  }),
})
